import { render, staticRenderFns } from "./NewAirport.vue?vue&type=template&id=04dcf84c"
import script from "./NewAirport.vue?vue&type=script&lang=js"
export * from "./NewAirport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports